import { useState } from 'react';
import toast from 'react-hot-toast';
import { listSilobagExtractionsService } from '@siloreal:shared:api/service/silobag/silobag-extraction-list';
import * as HOOKS from '@siloreal:shared:hooks';
import { useSilobagListContext } from '../context';
import { downloadSilobagExtractionReport } from '../extra/silobag-extraction-export';

function getExtractionReportFileName(label: string): string {
  const today = new Date();
  const date = [
    String(today.getDate()).padStart(2, '0'),
    String(today.getMonth() + 1).padStart(2, '0'),
    today.getFullYear(),
  ].join('-');

  return `${label} - ${date}`;
}

export function useHeaderExtractionExport() {
  const {
    organization: { current: organizationId },
  } = useSilobagListContext();

  const [isExporting, setIsExporting] = useState(false);

  const downloadReport = async (): Promise<void> => {
    if (isExporting) return;

    const i18n = HOOKS.useLocale.getState();
    const reportLabel = i18n.t('temp.private.list.common.actions.extraction_report');

    const loadingToastId = toast.loading(i18n.t('temp.common.toasts.loading.generating_extraction_report'));

    setIsExporting(true);

    try {
      const rows = await listSilobagExtractionsService({
        query: typeof organizationId === 'number' ? { organization_id: organizationId } : {},
      });

      const exportedCount = await downloadSilobagExtractionReport(
        rows,
        getExtractionReportFileName(reportLabel)
      );

      toast.success(
        i18n.t('temp.common.toasts.success.extraction_report_exported', {
          count: exportedCount,
        }),
        { id: loadingToastId }
      );
    } catch {
      toast.error(i18n.t('temp.common.toasts.error.extraction_report_export_failed'), { id: loadingToastId });
    } finally {
      setIsExporting(false);
    }
  };

  return {
    canExport: true,
    isExporting,
    download: () => void downloadReport(),
  };
}
